import {
  Button,
  Checkbox,
  Classes,
  Dialog,
  FileInput,
  FormGroup,
  H5,
  InputGroup,
  Popover,
  Radio,
  RadioGroup,
  Switch,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa } from "../../model";
import * as moment from "moment";
import { api, apiOperacao } from "../../api";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";

interface EmpresaCertificadoProps {
  goToTab: (tabId: string) => void;
}

interface EmpresaCertificadoState {
  sitfis_automatico: boolean
  manifestacao_automatica: boolean
  calculo_automatico_nivy: boolean
  manifestacao_automatica_nfse: boolean
  caixapostal_automatica: boolean
  dec_sefa: boolean
  rewritexml: boolean
  calculo_automatico_nivy_entrada: boolean
  calculo_automatico_nivy_saida: boolean
  nfe_fazenda_automatico: boolean
  download_via_manifestador: string
}

@observer
export default class EmpresaCertificado
  extends React.Component<EmpresaCertificadoProps, EmpresaCertificadoState> {
  obs = observable({
    empresa: {} as IEmpresa,
    handleModalRegimeLog: false as boolean,
    regimeAlteracao: "" as string,
    nome_certificado: "Selecione o certificado" as string,
    certificado: [] as any,
    open_ajuda: false as boolean,
    open_modal_ecac: false as boolean
  })

  constructor(props) {
    super(props);

    this.state = {
      sitfis_automatico: EmpresaStore.obs.empresa_edit.sitfis_automatico,
      manifestacao_automatica: EmpresaStore.obs.empresa_edit.manifestacao_automatica,
      calculo_automatico_nivy: EmpresaStore.obs.empresa_edit.calculo_automatico_nivy,
      manifestacao_automatica_nfse: EmpresaStore.obs.empresa_edit.manifestacao_automatica_nfse,
      caixapostal_automatica: EmpresaStore.obs.empresa_edit.caixapostal_automatica,
      dec_sefa: EmpresaStore.obs.empresa_edit.dec_sefa,
      rewritexml: EmpresaStore.obs.empresa_edit.rewritexml,
      calculo_automatico_nivy_entrada: EmpresaStore.obs.empresa_edit.calculo_automatico_nivy_entrada,
      calculo_automatico_nivy_saida: EmpresaStore.obs.empresa_edit.calculo_automatico_nivy_saida,
      nfe_fazenda_automatico: EmpresaStore.obs.empresa_edit.nfe_fazenda_automatico,
      download_via_manifestador: EmpresaStore.obs.empresa_edit.download_via_manifestador,
    };
  }

  deletaCertificado = async () => {

    try {

      var id = EmpresaStore.obs.empresa_edit.cipher_id;

      let resp = await apiOperacao("empresas").get(`/empresas/deleta-certificado?id=${id}`);

      if (resp.data.ok) {

        toast.success('Certificado deletado com sucesso', {});

        this.obs.nome_certificado = "Selecione o certificado"
        this.obs.certificado = []
        EmpresaStore.obs.empresa_edit.certificado = ""
        EmpresaStore.obs.empresa_edit.senha_certificado = ""

        EmpresaStore.obs.empresa_edit.sitfis_automatico = false
        EmpresaStore.obs.empresa_edit.manifestacao_automatica = false
        EmpresaStore.obs.empresa_edit.manifestacao_automatica_nfse = false
        EmpresaStore.obs.empresa_edit.caixapostal_automatica = false

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch(e){}

  };

  handleCancelRegime = () => {
    this.obs.handleModalRegimeLog = false;
    this.obs.regimeAlteracao = "";
  };

  handleConfirmRegime = () => {
    let regime = this.obs.regimeAlteracao;
    let empresa = EmpresaStore.obs.empresa_edit.cnpj;
    EmpresaStore.confirmRegimeLog(regime, empresa);
    EmpresaStore.obs.empresa_edit.regime_importacao = this.obs.regimeAlteracao;
    this.obs.handleModalRegimeLog = false;
  };

  handleChangeSitfis = (e) => {
    const newValue = e.target.checked;
    this.setState({ sitfis_automatico: newValue })
    EmpresaStore.obs.empresa_edit.sitfis_automatico = newValue;
  };

  handleChangeManifestacao = (e) => {
    const newValue = e.target.checked;
    this.setState({ manifestacao_automatica: newValue })
    EmpresaStore.obs.empresa_edit.manifestacao_automatica = newValue;
  };

  handleChangeCalculo = (e) => {
    const newValue = e.target.checked;
    this.setState({ calculo_automatico_nivy: newValue })
    EmpresaStore.obs.empresa_edit.calculo_automatico_nivy = newValue;
  };

  handleChangeManifestacaoNfse = async (e) => {
    const newValue = e.target.checked;

    let isOK = await EmpresaStore.handleValidaNfse(EmpresaStore.obs.empresa_edit.cnpj)

    if (isOK) {

      this.setState({ manifestacao_automatica_nfse: newValue })

      EmpresaStore.obs.empresa_edit.manifestacao_automatica_nfse = newValue;

    } else {
      toast.error('A ativação não é possível, pois exige o uso do certificado da própria empresa. Por favor, realize a importação do certificado correto.', {});

      this.setState({ manifestacao_automatica_nfse: false })

      EmpresaStore.obs.empresa_edit.manifestacao_automatica_nfse = false;

    }

  };

  async handleImportCertificado() {

    if (this.obs.certificado.length == 0) {
      toast.error('Você precisa selecionar o Certificado!', {});
      return;
    }

    if (!EmpresaStore.obs.empresa_edit.senha_certificado) {
      toast.error('Preencha a senha do certificado', {});
      return;
    }

    let senha: string = EmpresaStore.obs.empresa_edit.senha_certificado
    let cnpj: string = EmpresaStore.obs.empresa_edit.cnpj
    let filial: boolean = EmpresaStore.obs.empresa_edit.filial
    let certificado: any = this.obs.certificado

    var data = new FormData();
    data.append("filial", filial.toString());
    data.append("file", certificado);
    data.append("senha", senha);
    data.append("cnpj", cnpj);

    try {

      let resp = await apiOperacao("empresas").post("/empresas/upload-certificado", data)

      if (resp.data.ok) {
        EmpresaStore.obs.empresa_edit.certificado = resp.data.validade

        toast.success('Certificado importado com sucesso', {});

      } else {

        toast.error(resp.data.erro, {});

      }

    }catch(e){}

  }

  async handleDownloadPfx() {

    await EmpresaStore.downloadEmpresaPfx(EmpresaStore.obs.empresa_edit.cnpj)

  }

  handleChangeMovimento = (e) => {
    const newValue = e.target.value;
    this.setState({ rewritexml: newValue == "1" ? true : false })
    EmpresaStore.obs.empresa_edit.rewritexml = newValue == "1" ? true : false;
  };

  handleChangeCalculoEntrada = (e) => {
    const newValue = e.target.checked;
    this.setState({ calculo_automatico_nivy_entrada: newValue })
    EmpresaStore.obs.empresa_edit.calculo_automatico_nivy_entrada = newValue;
  };

  handleChangeCalculoSaida = (e) => {
    const newValue = e.target.checked;
    this.setState({ calculo_automatico_nivy_saida: newValue == "1" ? true : false  })
    EmpresaStore.obs.empresa_edit.calculo_automatico_nivy_saida = newValue == "1" ? true : false;
  };

  handleChangeModeloDownload = (e) => {
    const newValue = e.target.value;
    this.setState({ download_via_manifestador: newValue })
    EmpresaStore.obs.empresa_edit.download_via_manifestador = newValue;
  };

  handleGoToTab = (tab: string) => {
    this.props.goToTab(tab);
  };

  handleValidManiRS() {
    return (<>
      {AppStore.obs1.usuario.conta.certificado
        ?
        <FormGroup label="Manifestação NF-E e CT-E Automática">
          <Switch
            className="select-regras"
            label={EmpresaStore.obs.empresa_edit.manifestacao_automatica ? "Ativado" : "Desativado"}
            checked={EmpresaStore.obs.empresa_edit.manifestacao_automatica}
            onChange={(e: any) => this.handleChangeManifestacao(e)} />
        </FormGroup>
        :
        <>
          <FormGroup label="Manifestação NF-E e CT-E Automática">
            <p>Cadastre o Certificado do Contador em Perfil para poder Ativar!</p>
            <Switch
              label="Desativado"
              disabled
              checked={false} />
          </FormGroup>
        </>
      }
    </>)
  }

  handleValidManiPA() {
    return (<>
      {EmpresaStore.obs.empresa_edit.certificado
        ?
        <FormGroup label="Manifestação NF-E e CT-E Automática">
          <Switch
            className="select-regras"
            label={EmpresaStore.obs.empresa_edit.manifestacao_automatica ? "Ativado" : "Desativado"}
            checked={EmpresaStore.obs.empresa_edit.manifestacao_automatica}
            onChange={(e: any) => this.handleChangeManifestacao(e)} />
        </FormGroup>
        :
        <>
          <FormGroup label="Manifestação NF-E e CT-E Automática">
            <p>Cadastre o Certificado Digital para poder Ativar!</p>
            <Switch
              label="Desativado"
              disabled
              checked={false} />
          </FormGroup>
        </>
      }
    </>)
  }

  handleValidMani(estado: string) {

    if (estado == "RS") {

      return this.handleValidManiRS()

    }

    return this.handleValidManiPA()

  }

  handleChangeCaixapostal = (e) => {
    const newValue = e.target.checked;
    this.setState({ caixapostal_automatica: newValue });
    EmpresaStore.obs.empresa_edit.caixapostal_automatica = newValue;

    if (newValue) {
      this.obs.open_modal_ecac = true;
    }
  };

  handleChangeNfeFazenda = async (e) => {

    const newValue = e.target.checked;

    if(!newValue) {

      EmpresaStore.obs.empresa_edit.nfe_fazenda_automatico = newValue;
      return

    }

    let isOK = await EmpresaStore.handleValidaNfse(EmpresaStore.obs.empresa_edit.cnpj)

    if (isOK) {

      this.setState({ nfe_fazenda_automatico: newValue })

      EmpresaStore.obs.empresa_edit.nfe_fazenda_automatico = newValue;

    } else {
      toast.error('A ativação não é possível, pois exige o uso do certificado da própria empresa. Por favor, realize a importação do certificado correto.', {});

      this.setState({ nfe_fazenda_automatico: false })

      EmpresaStore.obs.empresa_edit.nfe_fazenda_automatico = false;

    }

  };

  render() {
    if (!EmpresaStore.obs.empresa_edit.plano_id) {
      EmpresaStore.obs.empresa_edit.plano_id = 0;
    }
    let contaPermissao = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.conta.teste
      : false;

    const handleFileInputChange = (event) => {
      const file = event.target.files[0];

      this.obs.nome_certificado = file.name
      this.obs.certificado = file

    };

    return (
      <>
        <div style={{ width: 1000 }}>

          {EmpresaStore.obs.empresa_edit.plano_id.toString() == "6220ff9a4c96f80fed0ddbc2"
            ? <h2 className="title">Plano SEFIP</h2>
            : (
              <>
                <MDBCol md="12">
                  <h2 className="title">Certificado Digital (A1)</h2>
                  {EmpresaStore.obs.empresa_edit.certificado
                    ? (
                      <>
                        <h3 className="info-cert">
                          Essa empresa possui um certificado em uso. <b />(Validade:{" "} {moment(EmpresaStore.obs.empresa_edit.certificado).format("DD/MM/YYYY")})
                        </h3>

                        <MDBRow md="12" style={{ marginLeft: 0 }}>
                          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position="bottom-left">
                            <Button intent="danger" icon="trash">Excluir Certificado</Button>
                            <div>
                              <H5>Confirmar exclusão?</H5>
                              <p>Atenção, deseja realmente excluir o certificado?</p>
                              <p>Ao deletar excluir, a FIPO não consultará mais os dados da empresa juntamente ao SEFAZ.</p>

                              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                                <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                                <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={this.deletaCertificado}>Excluir</Button>
                              </div>
                            </div>
                          </Popover>

                          <Button
                            style={{ marginLeft: 10 }}
                            icon="download"
                            onClick={() => this.handleDownloadPfx()}
                          >
                            Download PFX
                          </Button>
                        </MDBRow>

                      </>
                    )
                    : (
                      <>
                        <MDBRow>
                          <MDBCol md="6">
                            <FormGroup label="Selecionar Certificado Digital">
                              <FileInput text={this.obs.nome_certificado} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={handleFileInputChange} />
                            </FormGroup>
                          </MDBCol>

                          <MDBCol md="4">
                              <FormGroup label="Senha Certificado">
                                <InputGroup autoComplete="new-senha-certificado" name="new-senha-certificado" type="password" onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_certificado = e.target.value} />
                              </FormGroup>
                          </MDBCol>

                          <MDBCol md="2">
                            <Button onClick={(e) => this.handleImportCertificado()} intent="primary" style={{ marginTop: 26 }}>Importar</Button>
                          </MDBCol>

                        </MDBRow>
                      </>
                    )
                  }
                </MDBCol>

                <br />

                <MDBCol md="12">
                  {EmpresaStore.obs.empresa_edit.certificado
                    ?
                    <FormGroup label="Caixa Postal (RFB)">
                      <Switch
                        className="select-regras"
                        label={EmpresaStore.obs.empresa_edit.caixapostal_automatica ? "Ativado" : "Desativado"}
                        checked={EmpresaStore.obs.empresa_edit.caixapostal_automatica}
                        onChange={(e: any) => this.handleChangeCaixapostal(e)} />
                    </FormGroup>
                    :
                    <>
                      <FormGroup label="Caixa Postal (RFB)">
                        <p>Cadastre o Certificado Digital para poder Ativar!</p>
                        <Switch
                          label="Desativado"
                          disabled
                          checked={false} />
                      </FormGroup>
                    </>
                  }
                </MDBCol>
      
                {EmpresaStore.obs.empresa_edit.caixapostal_automatica && (
                  <MDBCol md="12">
                    <p style={{ marginTop: 10 }}>
                      Os avisos de novas mensagens por WhatsApp são configurados na aba{" "}
                      <button
                        onClick={() => this.handleGoToTab("notificacoes")}
                        style={{ padding: 0, border: "none", background: "none", fontWeight: "bold", textDecoration: "underline", color: "#3579ea", cursor: "pointer" }}
                      >
                        Notificações
                      </button>.
                    </p>
                  </MDBCol>
                )}

                <br />

                <MDBCol md="12">
                  {EmpresaStore.obs.empresa_edit.filial
                    ?
                    <>
                      <FormGroup label="Situação Fiscal (RFB) Automático">
                        <p>Exclusivo para Empresas Matriz!</p>
                        <Switch label="Desativado" disabled checked={false} />
                      </FormGroup>
                    </>
                    :
                    <>
                      {
                        EmpresaStore.obs.empresa_edit.certificado
                          ?
                          <FormGroup label="Situação Fiscal (RFB) Automático">
                            <Switch
                              className="select-regras"
                              label={EmpresaStore.obs.empresa_edit.sitfis_automatico ? "Ativado" : "Desativado"}
                              checked={EmpresaStore.obs.empresa_edit.sitfis_automatico}
                              onChange={(e: any) => this.handleChangeSitfis(e)} />
                          </FormGroup>

                          :
                          <>
                            <FormGroup label="Situação Fiscal (RFB) Automático">
                              <p>Cadastre o Certificado Digital para poder Ativar!</p>
                              <Switch
                                label="Desativado"
                                disabled
                                checked={false} />
                            </FormGroup>
                          </>
                      }
                    </>
                  }
                </MDBCol>

                <MDBCol md="12">

                  {this.handleValidMani(EmpresaStore.obs.empresa_edit.uf)}

                </MDBCol>

                <MDBCol md="12">
                  <FormGroup label="Importação de XML Automática SEFA">

                    <Switch
                      className="select-regras"
                      label={EmpresaStore.obs.empresa_edit.calculo_automatico_nivy ? "Ativado" : "Desativado"}
                      checked={EmpresaStore.obs.empresa_edit.calculo_automatico_nivy}
                      onChange={(e: any) => this.handleChangeCalculo(e)} 
                    />

                    {EmpresaStore.obs.empresa_edit.calculo_automatico_nivy && <>
                      <div className="nz-horizontal-form">
                        <div style={{width: 100}}>
                          <Checkbox className="select-regras" checked={EmpresaStore.obs.empresa_edit.calculo_automatico_nivy_entrada} label="Entrada" onChange={this.handleChangeCalculoEntrada} />
                        </div>
                        <div style={{width: 100}}>
                          <Checkbox className="select-regras" checked={EmpresaStore.obs.empresa_edit.calculo_automatico_nivy_saida} label="Saída" onChange={this.handleChangeCalculoSaida} />
                        </div>
                      </div>
                    </>}

                    {EmpresaStore.obs.empresa_edit.calculo_automatico_nivy &&
                      <RadioGroup onChange={(e: any) => this.handleChangeMovimento(e)} selectedValue={(EmpresaStore.obs.empresa_edit.rewritexml ? "1" : "0")} inline={true}>
                        <Radio label="Sobrescrever registros existentes" value="1" />
                        <Radio label="Importar somente registros inexistentes" value="0" />
                      </RadioGroup>
                    }

                  </FormGroup>

                </MDBCol>

                <MDBCol md="12">
                  {EmpresaStore.obs.empresa_edit.certificado ? (
                    <>
                      <FormGroup label="Download NFS-E Ambiente Nacional Automática">
                        <Switch
                          className="select-regras"
                          label={EmpresaStore.obs.empresa_edit.manifestacao_automatica_nfse ? "Ativado" : "Desativado"}
                          checked={EmpresaStore.obs.empresa_edit.manifestacao_automatica_nfse}
                          onChange={(e: any) => this.handleChangeManifestacaoNfse(e)}
                        />
                      </FormGroup>

                      {EmpresaStore.obs.empresa_edit.manifestacao_automatica_nfse && (
                        <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
                          O Download Automático de NFS-e pode levar até 24 horas para iniciar os downloads após a ativação.
                        </p>
                      )}
                    </>
                  ) : (
                    <FormGroup label="Download NFS-E Ambiente Nacional Automática">
                      <p>Cadastre o Certificado Digital para poder ativar!</p>

                      <Switch
                        label="Desativado"
                        disabled
                        checked={false}
                      />
                    </FormGroup>
                  )}
                </MDBCol>

                <MDBCol md="12">
                  {EmpresaStore.obs.empresa_edit.certificado
                    ?<>
                    <FormGroup label="Consultar NF-e Portal da Nota Fiscal Eletrônica" labelInfo={<>
                        &nbsp;<AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda = true} />
                      </>
                    }>
                      <Switch
                        className="select-regras"
                        label={EmpresaStore.obs.empresa_edit.nfe_fazenda_automatico ? "Ativado" : "Desativado"}
                        checked={EmpresaStore.obs.empresa_edit.nfe_fazenda_automatico}
                        onChange={(e: any) => this.handleChangeNfeFazenda(e)} />
                    </FormGroup>

                    {EmpresaStore.obs.empresa_edit.nfe_fazenda_automatico &&
                      <RadioGroup onChange={(e: any) => this.handleChangeModeloDownload(e)} selectedValue={EmpresaStore.obs.empresa_edit.download_via_manifestador} inline={true}>
                        <Radio label="Download XML via Manifestador" value="1" />
                        <Radio label="Download XML via Automação" value="0" />
                        <Radio label="Download XML via Automação e Ciência" value="2" />
                      </RadioGroup>
                    }
                    </>
                    :
                    <>
                      <FormGroup label="Consultar NF-e Portal da Nota Fiscal Eletrônica">
                        <p>Cadastre o Certificado Digital para poder Ativar!</p>
                        <Switch
                          label="Desativado"
                          disabled
                          checked={false} />
                      </FormGroup>
                    </>
                  }
                </MDBCol>

              </>
            )}

        </div>

        <Dialog
          isOpen={this.obs.handleModalRegimeLog}
          title="Atenção"
          onClose={() => this.obs.handleModalRegimeLog = false}
          style={{ width: 700 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="12">
                <h3 className="titleProccess">
                  Regime Selecionado: <u>{this.obs.regimeAlteracao}</u>
                </h3>
                <h3 className="titleProccess">
                  A alteração do regime irá impactar a data dos cálculos.
                </h3>
                <h3 className="titleProccess">
                  <u>
                    Certifique-se que realmente este é o regime da sua empresa e
                    aceite os termos para trocar o regime.
                  </u>
                </h3>
              </MDBCol>
            </MDBRow>
            <Button
              onClick={() => this.handleCancelRegime()}
              className="cancelCadEmp"
            >
              Cancelar
            </Button>
            <Button
              onClick={() => this.handleConfirmRegime()}
              className="certiDigitalTeste"
            >
              Aceito os Termos
            </Button>
          </div>
        </Dialog>

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`
          As notas fiscais serão buscadas com base no certificado digital vinculado. Se a filial utilizar o certificado da matriz, serão retornadas as notas fiscais da matriz. 
          <br/><br/>
          Para disponibilizar as notas no <b>Manifestador</b>, ative a opção <b>Download XML via Automação e Ciência</b>.
          <br/><br/>
          Ao ativar essa opção, o sistema fará automaticamente a <b>Ciência</b> dessas notas.
        `} />

      </>
    );
  }
}
